import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateMRDCMobile } from "@/api/v1-jwt/mrdc/mrdc";

export const useUpdateMRDCMobile = () => {
  const query = useQueryClient();

  return useMutation({
    mutationFn: updateMRDCMobile,
    onSettled: () => {
      query.invalidateQueries(["mrdc"]);
    },
  });
};
